import styled from "styled-components";

export const WrapperTextInput = styled.label`
  > p {
    color: #2d2d2d;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    margin-top: 16px;

    > span {
      font-weight: 700;
    }
  }
`;

export const TextInputItem = styled.textarea`
  resize: none;
  outline: none;

  border-radius: 10px;
  border: 1px solid #9d9d9d;
  background: #fff;
  width: 100%;
  height: 170px;
  padding: 16px;
`;
